import React from "react";
import { LibraryCard } from "./LibraryCard";
import { LibraryUIProvider } from "./LibraryUIContext";

export function LibraryPage({ history, match }) {
  console.log(`match`, match);
  const libraryUIEvents = {
    openEditLibraryPage: id => {
      history.push(`/elibrary/${id}/detail`);
    },
    openLibraryFilePage: id => {
      history.push(`/elibrary/file/${id}`);
    }
  };

  return (
    <LibraryUIProvider libraryUIEvents={libraryUIEvents}>
      <LibraryCard history={history} match={match} />
    </LibraryUIProvider>
  );
}
